export const required = 'Campo obrigatório';
export const emailValid = 'Formato de e-mail inválido';
